import { Card, SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

/**
 * Placeholder shaped like the edit-mode editor (spec readout, Items, preferred)
 * shown while the Appliance loads. Add mode has nothing to load, so it has no
 * skeleton — the form shell renders straight away.
 */
const ApplianceEditorSkeleton: FC = () => (
  <div>
    <Card sizeVariant="lg" className="mb-4">
      <Card.Body className="flex flex-col gap-4">
        <SkeletonLoader className="h-6 w-56 rounded-md" />
        <div className="rounded-xl border border-gray-200 bg-white p-5">
          <div className="-mx-5 mb-4 flex items-center gap-3 border-b border-gray-200 px-5 pb-4">
            <SkeletonLoader className="h-16 w-16 shrink-0 rounded-md" />
            <div className="flex min-w-0 flex-col gap-2">
              <SkeletonLoader className="h-4 w-48 rounded-md" />
              <SkeletonLoader className="h-3 w-32 rounded-md" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-x-7 gap-y-4 lg:grid-cols-3">
            {['a', 'b', 'c', 'd', 'e'].map((key) => (
              <div key={key} className="flex flex-col gap-2">
                <SkeletonLoader className="h-3 w-16 rounded-md" />
                <SkeletonLoader className="h-4 w-20 rounded-md" />
              </div>
            ))}
          </div>
        </div>
      </Card.Body>
    </Card>

    <Card sizeVariant="lg" className="mb-4">
      <Card.Body className="flex flex-col gap-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex flex-col gap-2">
            <SkeletonLoader className="h-6 w-24 rounded-md" />
            <SkeletonLoader className="h-3 w-64 rounded-md" />
          </div>
          <SkeletonLoader className="h-9 w-24 shrink-0 rounded-md" />
        </div>
        <div className="flex flex-col">
          {['one', 'two'].map((key) => (
            <div
              key={key}
              className="flex items-center justify-between border-t border-gray-100 py-3 last:border-b"
            >
              <SkeletonLoader className="h-4 w-56 rounded-md" />
              <SkeletonLoader className="h-4 w-16 rounded-md" />
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>

    <Card sizeVariant="lg" className="mb-4">
      <Card.Body className="flex items-center justify-between gap-5">
        <div className="flex min-w-0 flex-col gap-2">
          <SkeletonLoader className="h-6 w-40 rounded-md" />
          <SkeletonLoader className="h-3 w-full max-w-md rounded-md" />
        </div>
        <SkeletonLoader className="h-6 w-11 shrink-0 rounded-full" />
      </Card.Body>
    </Card>

    <div className="flex justify-end gap-2">
      <SkeletonLoader className="h-10 w-24 rounded-md" />
      <SkeletonLoader className="h-10 w-32 rounded-md" />
    </div>
  </div>
);

export default ApplianceEditorSkeleton;
